class PredictiveSearch extends MenuDrawer {
  constructor() {
    super();
  }

  getInitialSearchResults() {
    fetch(`${routes.search_url}?view=predictive-search-defaults`)
      .then((res) => res.text())
      .then((html) => {
        this.predictiveSearchResults.innerHTML = html;

        const fallbackElement = document.querySelector(
          '[js-predictive-search-data]',
        );
        if (fallbackElement && fallbackElement.innerHTML) return;
        fallbackElement.innerHTML = html;
      })
      .catch((err) => console.error(err));
  }

  connectedCallback() {
    this.cachedResults = {};
    this.input = this.querySelector('input[role="combobox"]');
    this.predictiveSearchResults = this.querySelector(
      'predictive-search-results',
    );

    this.summaryUnlockScreen();

    this.setupEventListeners();

    // window.setTimeout(() => this.getInitialSearchResults(), 500);
  }

  summaryUnlockScreen() {
    const summary = this.querySelector('summary');
    if (!summary) return;
    summary.addEventListener('click', () => {
      setTimeout(() => {
        if (summary.parentElement.hasAttribute('open')) return;

        bodyScroll.clear();
      }, 0);
    });
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    // bodyScroll.lock(summaryElement.nextElementSibling);
  }

  setupEventListeners() {
    const form = this.querySelector('form');
    form.addEventListener('submit', this.onFormSubmit.bind(this));

    form.addEventListener('click', (event) => {
      event.stopPropagation();
    });

    this.input.addEventListener(
      'input',
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    document.addEventListener(
      'predictive-search:restore-defaults',
      this.restoreDefaultRecommendations.bind(this),
    );

    //listen for enter key for mobile search submission
    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.querySelector('form').submit(); // Ensure form submission
      }
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  hasQuery() {
    return !!this.getQuery().length;
  }

  restoreDefaultRecommendations() {
    const resultsMarkup = document.querySelector('[js-predictive-search-data]');
    if (!resultsMarkup) return this.close(true);
    this.renderSearchResults(resultsMarkup.innerHTML);
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!this.hasQuery()) {
      return this.restoreDefaultRecommendations();
    }

    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    console.log(this.getQuery());
    if (!this.hasQuery()) event.preventDefault();
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!this.hasQuery()) return;

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    }, 0);
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm,
      )}&${encodeURIComponent(
        'resources[type]',
      )}=product,query&${encodeURIComponent(
        'resources[limit]',
      )}=5&section_id=predictive-search`,
    )
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  populateSearchResults(html = '') {
    this.predictiveSearchResults.innerHTML = html;
  }

  renderSearchResults(resultsMarkup) {
    this.populateSearchResults(resultsMarkup);
    this.open();
  }

  open() {
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('open');
    }

    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);

    bodyScroll.clear();
  }
}

customElements.define('predictive-search', PredictiveSearch);
